import { render } from "./ClubDealValue.vue?vue&type=template&id=23ff38e2&scoped=true&ts=true"
import script from "./ClubDealValue.vue?vue&type=script&lang=ts"
export * from "./ClubDealValue.vue?vue&type=script&lang=ts"

import "./ClubDealValue.vue?vue&type=style&index=0&id=23ff38e2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ff38e2"]])

export default __exports__